import { useEffect, useMemo } from "react";
import { IVideo } from "../interfaces";
import useApi from "./useApi";
import { IQuery } from "../component/history/HistoryFilter";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { NEW_BASE_URL } from "../api";

interface IList {
  videos?: IVideo[];
  count?: number;
}

function cleanQuery(query: Record<string, any>) {
  const cleaned: Record<string, any> = {};
  for (const key in query) {
    if (key === "videoType") continue;
    const value = query[key];
    if (key === "page" || key === "pageSize") {
      cleaned[key] = value;
      continue;
    }
    if (value !== "" && value !== null && value !== undefined) {
      cleaned[key] = value;
    }
  }
  return cleaned;
}

export default function useList(videoType: "yt" | ""|"kgs") {
  const search = useSearch({ from: videoType === "yt" ? "/youtube" : "/list" });
  const navigate = useNavigate();

  const query: IQuery = useMemo(
    () => ({
      title: search.title ?? undefined,
      vid: search.vid ?? undefined,
      status: search.status ?? undefined,
      courseId: search.courseId ?? undefined,
      lessonId: search.lessonId ?? undefined,
      date: search.date ?? undefined,
      page: search.page ? Number(search.page) : 1,
      pageSize: search.pageSize ? Number(search.pageSize) : 10,
      videoType:
      videoType === "yt"
        ? "yt,youtube"
        : videoType,
      stream_key: search.stream_key ?? undefined,
    }),
    [search, videoType],
  );

  const { data, isLoading, load, updateData } = useApi<IList>(
    NEW_BASE_URL + "videos",
    [],
  );

  const updateQuery = (newQuery: Partial<IQuery>) => {
    navigate({
      search: cleanQuery({ ...query, ...newQuery }),
      replace: true,
    });
  };

  const onDelete = (video: IVideo) => {
    const update = {
      videos: data?.videos?.filter((v) => v._id !== video._id),
      count: data?.count,
    };
    updateData(update);
  };

  const updateList = (video: IVideo) => {
    const update = {
      videos: data?.videos?.map((v) =>
        v._id === video?._id ? { ...v, ...video } : v,
      ),
      count: data?.count,
    };
    updateData(update);
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      load(query);
    }, 500);
    return () => clearTimeout(getData);
  }, [query, load]);

  return {
    list: data,
    query,
    updateList,
    isLoading,
    updateQuery,
    onDelete,
  };
}
